var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganisationCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3867_74495)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.943 11.4147C14.3669 11.4147 13.0893 12.6923 13.0893 14.2684C13.0893 15.8444 14.3669 17.122 15.943 17.122C17.519 17.122 18.7966 15.8444 18.7966 14.2684C18.7966 12.6923 17.519 11.4147 15.943 11.4147ZM11.6624 14.2684C11.6624 11.9043 13.5789 9.98786 15.943 9.98786C18.307 9.98786 20.2235 11.9043 20.2235 14.2684C20.2235 16.6324 18.307 18.5489 15.943 18.5489C13.5789 18.5489 11.6624 16.6324 11.6624 14.2684Z",
    fill: "#90979B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24169 11.4147C3.66565 11.4147 2.38802 12.6923 2.38802 14.2684C2.38802 15.8444 3.66565 17.122 5.24169 17.122C6.81773 17.122 8.09536 15.8444 8.09536 14.2684C8.09536 12.6923 6.81773 11.4147 5.24169 11.4147ZM0.961182 14.2684C0.961182 11.9043 2.87763 9.98786 5.24169 9.98786C7.60575 9.98786 9.52219 11.9043 9.52219 14.2684C9.52219 16.6324 7.60575 18.5489 5.24169 18.5489C2.87763 18.5489 0.961182 16.6324 0.961182 14.2684Z",
    fill: "#90979B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5923 1.78346C9.01628 1.78346 7.73865 3.0611 7.73865 4.63714C7.73865 6.21317 9.01628 7.49081 10.5923 7.49081C12.1684 7.49081 13.446 6.21317 13.446 4.63714C13.446 3.0611 12.1684 1.78346 10.5923 1.78346ZM6.31181 4.63714C6.31181 2.27308 8.22826 0.356628 10.5923 0.356628C12.9564 0.356628 14.8728 2.27308 14.8728 4.63714C14.8728 7.00119 12.9564 8.91764 10.5923 8.91764C8.22826 8.91764 6.31181 7.00119 6.31181 4.63714Z",
    fill: "#90979B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.943 11.4147C14.3669 11.4147 13.0893 12.6923 13.0893 14.2684C13.0893 15.8444 14.3669 17.122 15.943 17.122C17.519 17.122 18.7966 15.8444 18.7966 14.2684C18.7966 12.6923 17.519 11.4147 15.943 11.4147ZM11.6624 14.2684C11.6624 11.9043 13.5789 9.98786 15.943 9.98786C18.307 9.98786 20.2235 11.9043 20.2235 14.2684C20.2235 16.6324 18.307 18.5489 15.943 18.5489C13.5789 18.5489 11.6624 16.6324 11.6624 14.2684Z",
    stroke: "#90979B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24169 11.4147C3.66565 11.4147 2.38802 12.6923 2.38802 14.2684C2.38802 15.8444 3.66565 17.122 5.24169 17.122C6.81773 17.122 8.09536 15.8444 8.09536 14.2684C8.09536 12.6923 6.81773 11.4147 5.24169 11.4147ZM0.961182 14.2684C0.961182 11.9043 2.87763 9.98786 5.24169 9.98786C7.60575 9.98786 9.52219 11.9043 9.52219 14.2684C9.52219 16.6324 7.60575 18.5489 5.24169 18.5489C2.87763 18.5489 0.961182 16.6324 0.961182 14.2684Z",
    stroke: "#90979B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5923 1.78346C9.01628 1.78346 7.73865 3.0611 7.73865 4.63714C7.73865 6.21317 9.01628 7.49081 10.5923 7.49081C12.1684 7.49081 13.446 6.21317 13.446 4.63714C13.446 3.0611 12.1684 1.78346 10.5923 1.78346ZM6.31181 4.63714C6.31181 2.27308 8.22826 0.356628 10.5923 0.356628C12.9564 0.356628 14.8728 2.27308 14.8728 4.63714C14.8728 7.00119 12.9564 8.91764 10.5923 8.91764C8.22826 8.91764 6.31181 7.00119 6.31181 4.63714Z",
    stroke: "#90979B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3867_74495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationCircles);
export default __webpack_public_path__ + "static/media/organisationCircles.e754a68c.svg";
export { ForwardRef as ReactComponent };